import { createRouter, createWebHistory } from 'vue-router'
import { useSessionStore } from '../stores/session'
import DashboardLayout from '../layouts/DashboardLayout.vue'
import DashboardView from '../pages/Dashboard.vue'
import LoggedOutLayout from '../layouts/LoggedOutLayout.vue'
import LoginView from '../pages/Login.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      component: LoggedOutLayout,
      children: [
        {
          path: '',
          name: 'login',
          component: LoginView,
        },
      ],
      meta: { requiresAuth: false },
    },
    {
      path: '/',
      component: DashboardLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'home',
          redirect: '/plans',
        },
        {
          path: 'plans',
          name: 'plans',
          component: DashboardView,
        },
        {
          path: 'plan/:paymentPlanId',
          name: 'plan-detail',
          component: () => import('../pages/Plan.vue'),
        },
      ],
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/plans',
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const sessionStore = useSessionStore()

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false)

  if (to.path === '/login') {
    if (to.path === '/login' && sessionStore.isAuthenticated) {
      return next('/plans')
    }
    return next()
  }

  if (requiresAuth) {
    if (!sessionStore.isAuthenticated && !sessionStore.isLoading) {
      try {
        await sessionStore.checkSession()
      } catch {
        return next({ path: '/login', query: { returnTo: to.fullPath } })
      }
    }

    if (!sessionStore.isAuthenticated) {
      return next('/login')
    }
  }

  return next()
})

export default router
